import { render, staticRenderFns } from "./increment-decrement.vue?vue&type=template&id=0b9f2801&scoped=true"
import script from "./increment-decrement.vue?vue&type=script&lang=js"
export * from "./increment-decrement.vue?vue&type=script&lang=js"
import style0 from "./increment-decrement.vue?vue&type=style&index=0&id=0b9f2801&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9f2801",
  null
  
)

export default component.exports